export default __webpack_public_path__ + "static/media/twix.dfef361e.png";